import React, { useState, useEffect } from "react"
import { sortData } from "../../utils/common"
import { get } from "../../utils/apiClient"
import moment from "moment-timezone"
import Pagination from "../common/pagination"

function History({ selectedFax, faxNumberToDisplay, authUser }) {
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [sortConfig, setSortConfig] = useState({
    key: "timestamp",
    direction: "desc",
  })
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const historyPerPage = 10

  const fetchHistory = async () => {
    try {
      const faxId = selectedFax.fax_id || selectedFax.faxId
      const data = await get(`/fax/auditLogs?faxId=${faxId}`)
      setHistory(data)
    } catch (error) {
      console.error("Failed to fetch history", error)
      setHistory([])
    }
  }

  const loadHistory = async () => {
    setLoading(true)
    await fetchHistory()
    setLoading(false)
  }

  const handleExportCsv = () => {
    // if (history.length === 0) {
    //   toast.error("No data to export")
    //   return
    // }
    // CSV header
    // CSV header
    const headers = ["Fax Number", "Action", "Time", "Username"]
    // Build rows
    const rows = history.map((history) => [
      history.faxNumber,
      history.faxAction,
      moment
        .unix(history.timestamp)
        .tz("America/New_York")
        .format("MM/DD/YYYY hh:mm A"),
      history.userName,
    ])
    // Assemble CSV string
    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map(
            (cell) =>
              // escape quotes
              `"${String(cell).replace(/"/g, '""')}"`
          )
          .join(",")
      )
      .join("\n")
    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `${faxNumberToDisplay}_history.csv`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
  }

  useEffect(() => {
    loadHistory()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFax.fax_id])

  // const filteredHistory =
  //   history?.filter((phonebook) =>
  //     Object.values(phonebook).some((value) =>
  //       value.toString().toLowerCase().includes(searchText.toLowerCase())
  //     )
  //   ) || []

  const sortedHistory = sortData(history, sortConfig)

  return (
    <div className="faxes-content">
      {loading ? (
        <div className="loading-container">
          <div className="loading-pdf-message">Loading ...</div>
        </div>
      ) : (
        <>
          <div className="table-container">
            <table className="faxes-table" style={{ marginTop: "5px" }}>
              <thead>
                <tr>
                  {/* <th
                    className="faxes-th"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      setSortConfig({
                        key: "faxNumber",
                        direction:
                          sortConfig.direction === "asc" ? "desc" : "asc",
                      })
                    }
                  >
                    Fax Number
                    <span>
                      {sortConfig.direction
                        ? sortConfig.key === "faxNumber"
                          ? sortConfig.direction === "asc"
                            ? " 🔼"
                            : " 🔽"
                          : " ↕️"
                        : ""}
                    </span>
                  </th> */}
                  <th className="faxes-th">Action</th>
                  <th className="faxes-th">Time</th>
                  <th className="faxes-th">Username</th>
                </tr>
              </thead>
              <tbody>
                {sortedHistory.length > 0 ? (
                  sortedHistory?.map((history) => (
                    <tr
                      key={history.faxNumber}
                      className="fax-item"
                      style={{ cursor: "unset" }}
                    >
                      {/* <td className="faxes-td">{history?.faxNumber}</td> */}
                      <td className="faxes-td">{history?.faxAction}</td>
                      {/* <td className="faxes-td">{phonebook.faxId}</td> */}
                      <td className="faxes-td">
                        {moment
                          .unix(history.createdDatetime)
                          .tz("America/New_York")
                          .format("MM/DD/YYYY hh:mm A")}
                      </td>
                      <td className="faxes-td">{history?.userName}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="100%"
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        border: "1px solid #ccc",
                      }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            className="faxes-pagination"
            style={{
              marginTop: "5px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              {(authUser.userRole === "SUPER_ADMIN" ||
                authUser.userRole === "ADMIN") && (
                <button
                  className="faxes-button"
                  onClick={handleExportCsv}
                  style={{ marginLeft: "0px" }}
                >
                  Export to CSV
                </button>
              )}
            </div>
            {sortedHistory.length > 0 && (
              <div
                className="faxes-pagination"
                style={{
                  marginTop: "8px",
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                {sortedHistory.length > 0 && (
                  <Pagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(
                      sortedHistory.length / historyPerPage
                    )}
                    rowsPerPage={rowsPerPage}
                    totalRows={sortedHistory.length}
                    onPageChange={(page) => setCurrentPage(page)}
                    onRowsPerPageChange={(count) => {
                      setRowsPerPage(count)
                      setCurrentPage(1) // Reset to first page on change
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default History
